<mat-card class="full-stretch">
    <mat-card-header class="border-primary-bottom flex-row flex--align-center padding-standard flex--justify-between">
        <mat-card-title class="mat-headline-4">{{'ss-unauthorized.title' | translate}}</mat-card-title>
        <button mat-icon-button (click)="navigateAway()">
            <mat-icon >close</mat-icon>
        </button>
    </mat-card-header>
    <mat-card-content class="flex-column flex--align-center padding-standard gap-standard">
        
        <ss-logo-solo 
            [dark]="true"
        ></ss-logo-solo>
        
        <p class="warn-text mat-headline-4"> {{'ss-unauthorized.message' | translate}}</p>

        <div class="divider-2 full-width"></div>
        <p class="mat-headline-6"> {{'ss-unauthorized.message-2' | translate}}</p>

    </mat-card-content>
</mat-card>